import { render, staticRenderFns } from "./AffirmNewsandFeatures.vue?vue&type=template&id=1660de66&"
import script from "./AffirmNewsandFeatures.vue?vue&type=script&lang=js&"
export * from "./AffirmNewsandFeatures.vue?vue&type=script&lang=js&"
import style0 from "./AffirmNewsandFeatures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports